<template>
  <y-shelf title="安全中心">
    <span slot="right"></span>
    <div slot="content">
      <div class="deposit-main">
        <el-table
          :data="tableData"
          style="width: 100%"
          :show-header="false">
          <el-table-column
            prop="setting"
            label="是否设置"
            width="100">
        　　<template slot-scope="scope">
              <span v-if="scope.row.setting=='已设置'">
                <p><i style="padding-right: 5px; color:#55aa00;" class="el-icon-success"/>{{scope.row.setting}}</p>
              </span>
              <span v-if="scope.row.setting=='未设置'">
                <p style="color:#f00;"><i style="color:#f00; padding-right: 5px;" class="el-icon-error"/>{{scope.row.setting}}</p>
              </span>
        　　</template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名字"
            width="120">
            <template slot-scope="scope">
              <p style="font-weight: bolder;">{{scope.row.name}}</p>
        　　</template>
          </el-table-column>
          <el-table-column
            prop="tip"
            label="描述">
            <template slot-scope="scope">
              <p style="color: #999;">{{scope.row.tip}}</p>
        　　</template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="updataRow(scope.$index, tableData)"
                type="text"
                size="small">
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>


    <div class="box-dialog">
      <!-- 修改密码模态框 -->
      <el-dialog title="修改密码" :visible.sync="dialogPasswordForm" >
        <div class="box">
          <ul class="common-form">
            <li>
              <div class="update-input">
                <input type="phone" v-model="change.userName" placeholder="手机号码"
                  @keyup="change.userName = change.userName.replace(/[^\w\.\/]/ig,'')">
              </div>
            </li>
            <li>
              <div class="input-sms">
                <input type="number" v-model="change.smsCode" :disabled="!smsFlag" placeholder="短信验证码" >
                <y-button
                    :classStyle="change.userName.length === 11 && !smsFlag && smstxt === '获取验证码'?'main-btn':'disabled-btn'"
                    :text="smstxt" style="margin:0;width: 120px;" @btnClick="snedSmsCode">
                  </y-button>
                </div>
            </li>
            <li>
              <div class="update-input">
                <input type="password" v-model="change.userPwd" placeholder="新密码">
              </div>
            </li>
          </ul>
          <div style="margin: 20px 0;">
            <y-button
                :classStyle="change.userPwd&& change.userName && change.smsCode && updatetxt === '修改密码'?'main-btn':'disabled-btn'"
                :text="updatetxt" style="margin: 0;width: 300px;height: 48px;font-size: 18px;line-height: 48px"
                @btnClick="changePassword">
            </y-button>
          </div>

        </div>

        <div class="border" style="margin-bottom: 10px;"></div>

      </el-dialog>
      <!-- 绑定手机号模态框 -->
      <el-dialog title="手机绑定" :visible.sync="dialogPhoneVisible">
        <div class="box">
          <ul class="common-form">
            <li>
              <div class="update-input">
                <input type="phone" v-model="change.userName" placeholder="手机号码"
                  @keyup="change.userName = change.userName.replace(/[^\w\.\/]/ig,'')">
              </div>
            </li>
            <li>
              <div class="input-sms">
                <input type="number" v-model="change.smsCode" :disabled="!smsFlag" placeholder="短信验证码" >
                <y-button
                    :classStyle="change.userName.length === 11 && !smsFlag && smstxt === '获取验证码'?'main-btn':'disabled-btn'"
                    :text="smstxt" style="margin:0;width: 120px;" @btnClick="snedSmsCode">
                  </y-button>
                </div>
              </li>
          </ul>
          <div style="margin: 20px 0;">
            <y-button
                :classStyle="change.userPwd&& change.userName && change.smsCode && updatephonetxt === '修改手机号码'?'main-btn':'disabled-btn'"
                :text="updatephonetxt" style="margin: 0;width:295px;height: 48px;font-size: 18px;line-height: 48px"
                @btnClick="changePhone">
            </y-button>
          </div>

        </div>

        <div class="border" style="margin-bottom: 10px;"></div>

      </el-dialog>
    </div>

      </div>
    </div>
  </y-shelf>
</template>

<script>
  import YShelf from '/components/YShelf'
  import YButton from '/components/YButton'
  export default {
     data() {
      return {
        tableData: [{
          setting: '已设置',
          name: '登录密码',
          tip: '上次登录时间：2022年10月3日 21:00'
        }, {
          setting: '未设置',
          name: '手机绑定',
          tip: '绑定手机用来接收支付、登录等操作的短信验证码，提高账号和交易的安全性。'
        }, {
          setting: '未设置',
          name: '邮箱绑定',
          tip: '绑定邮箱用来接收消息、登录等操作的验证码，提高账号的安全性。'
        }, {
          setting: '已设置',
          name: '消息接收',
          tip: '设置邮箱接收或短信接收'
        }],
        dialogPasswordForm: false,
        dialogPhoneVisible: false,
        change: {
          userName: '',
          userPwd: '',
          smsCode: '',
          errMsg: ''
        },
        updatetxt: '修改密码',
        updatephonetxt: '修改手机号码',
        smstxt: '获取验证码',
        smsFlag: false,
      }
    },
    methods:{
      updataRow(index,tableData){
        if(index === 0){
        this.dialogPasswordForm = true
        }else if(index === 1){
        this.dialogPhoneVisible = true
        }
      },
      snedSmsCode() {
        console.log('this.change.userName: ',this.change.userName);
        this.$api.get({
            url: '/common/sendSMS',
            data:{
              mobile:this.change.userName
            }
        }).then(res=>{
          console.log('res: ',res);
          if(res.code==200) {
            this.$yxz.msg('验证码发送成功','success');
            this.smsFlag = true
          }
        })
      },
      open(t, m) {
        this.$notify.info({
          title: t,
          message: m
        })
      },
      message(m) {
        this.$message.error({
          message: m
        })
      },
      changePassword() {
        this.updatetxt = '正在修改密码...'
        let userName = this.change.userName
        let userPwd = this.change.userPwd
        let smsCode = this.change.smsCode
        if (!userName || !userPwd ) {
          this.$yxz.msg('账号密码不能为空!')
          this.updatetxt = '修改密码'
          return false
        }
        if (!smsCode) {
          this.$yxz.msg('短信验证码不能为空')
          this.updatetxt = '修改密码'
          return false
        }
        this.$api.post({
          url:'/resetPassword',
          data: {
              loginName: userName,
              loginPassword: userPwd,
              smsCode: smsCode
          }
        }).then(res => {
          if (res.code == 200) {
             this.$yxz.msg('修改成功;','success')
             this.toLogin()
          } else {
            this.$yxz.msg(res.msg)
            this.updatetxt = '修改密码'
            return false
          }
        })
      },
      changePhone() {
        this.updatephonetxt = '正在修改手机号码...'
        let userName = this.change.userName
        let smsCode = this.change.smsCode
        if (!userName) {
          this.$yxz.msg('手机号码不能为空!')
          this.updatephonetxt = '修改手机号码'
          return false
        }
        if (!smsCode) {
          this.$yxz.msg('短信验证码不能为空')
          this.updatephonetxt = '修改手机号码'
          return false
        }
        this.$api.post({
          url:'/resetPassword',
          data: {
              loginName: userName,
              smsCode: smsCode
          }
        }).then(res => {
          if (res.code == 200) {
             this.$yxz.msg('修改成功;','success')
             this.toLogin()
          } else {
            this.$yxz.msg(res.msg)
            this.updatephonetxt = '修改手机号码'
            return false
          }
        })
      }
    },
    mounted() {
      this.$yxz.title("医小智 - 修改设置")
    },
    components: {
      YShelf,
      YButton
    }
  }
</script>

<style lang="scss" scoped>
  .deposit-main {
    margin: 30px 50px 100px 50px;
  }
  .update-input{
    width:370px;
    height: 50px;
    display: flex;
    align-items: center;
    input {
      font-size: 16px;
      width: 295px;
      height: 50px;
      padding: 10px 15px;
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 6px;
    }
  }
  .input-sms {
      height: 50px;
      width: 370px;
      display: flex;
      align-items: center;
      input {
        font-size: 16px;
        width:165px;
        height: 50px;
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin-right: 10px;
      }
    }
  .box {
      width: 300px;
      padding-bottom: 30px;
      height: auto;
      margin:0 auto;
      .common-form {
        li {
          clear: both;
          margin-bottom: 15px;
          position: relative;
        }
      }
    }
</style>
<style>
  .el-dialog{
    width: 35%;
  }
</style>



// WEBPACK FOOTER //
// safeCenter.vue?4033caaa